<template>
  <div id="home" v-loading.fullscreen.lock="changeLoading">
    <div style="background-color: white; margin: 10px 20px">
      <div class="pos_container_panel" style="padding-left: 2rem">
        <!--search area-->
        <el-form
          :inline="true"
          :model="searchForm"
          class="demo-form-inline"
          style="margin-left: 6rem; padding-top: 2rem"
        >
          <el-row style="">
            <el-col :span="16"
              ><div class="grid-content bg-purple">
                <el-form-item label="国家">
                  <el-select
                    default-first-option
                    filterable
                    v-model="searchForm.nation"
                    placeholder="国家"
                    style="width: 82%; margin-left: 3.5rem"
                    @change="selectNation"
                    clearable
                  >
                    <el-option
                      v-for="item in nationoption"
                      :key="item.countryCode"
                      :label="item.countryNameLists['zh-CN']"
                      :value="item.countryCode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item></div
            ></el-col>
            <el-col :span="8"
              ><div class="grid-content bg-purple-light"></div
            ></el-col>
            <el-col :span="8"
              ><div class="grid-content bg-purple"></div
            ></el-col>
          </el-row>
          <el-row>
            <el-col :span="24" style="float: right">
              <div class="grid-content bg-purple-light" style="float: right">
                <el-button
                  type="warning"
                  class="harpIDbtn"
                  @click="customSearch()"
                >
                  搜索</el-button
                >
                <el-button
                  type="warning"
                  class="harpIDbtn"
                  style="margin-left: 3rem"
                  @click="addCountry()"
                >
                  新增
                </el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
        <hr
          style="
            margin: 1rem -14rem 0rem;
            background-color: rgb(241 243 245);
            height: 0.2rem;
            border: none;
          "
        />
        <!--table-->
        <el-table
          :data="tableData"
          border
          style="width: 90%; margin-top: 50px; margin-left: 100px"
        >
          <el-table-column
            prop="countryCode"
            label="国家代码"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="countryNameLists.zh-CN"
            label="国家名称-中文"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="countryNameLists.en"
            label="国家名称-英文"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="currencyCode"
            label="当地货币"
            align="center"
          ></el-table-column>
         <el-table-column label="操作" width="200" align="center">
            <template #default="scope">
              <el-button @click="bindMapping(scope.row)" type="text" size="small">关联映射</el-button>
              <el-button type="text" size="small" @click.prevent="deleteMapping(scope.row)">删除映射</el-button>
              <el-button @click="handleChange(scope.row)" type="text" size="small">修改</el-button>
              <el-button type="text" size="small" @click.prevent="deleteRow(scope.row)">删除</el-button>
              <el-button v-if="scope.row.enableFlag" type="text" size="small" @click.prevent="enable(scope.row)">启用</el-button>
              <el-button v-if="scope.row.disabledFlag" type="text" size="small" @click.prevent="disabled(scope.row)">禁用</el-button>
              <el-button type="text" size="small" @click.prevent="updateIntlTaxDisplay(scope.row)">
                {{ scope.row.intlTaxDisplay ? '不提示额外税费' : '提示额外税费' }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-bottom: 1rem">
          <el-pagination
            class="paginationsty"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            v-model:current-page="currentPage1"
            :page-size="10"
            layout="total, prev, pager, next"
            :total="searchForm.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <ConfirmBoxs
      :centerDialogVisible="confirmFlag"
      :confirmMsg="confirmMsg"
      :icon="confirmIcon"
      @setConfirmFlag="setConfirmFlag"
    ></ConfirmBoxs>
    <!--新增 dialog-->
    <el-dialog title="新增国家" v-model="dialogFormVisible">
      <el-form :model="form" ref="checkInput">
        <el-form-item
          prop="countryCode"
          label="国家代码:"
          :label-width="formLabelWidth"
          :rules="[
            { required: true, message: '请输入国家代码', trigger: 'blur' },
          ]"
        >
          <el-input v-model="form.countryCode" autocomplete="off" style="width: 58%; margin-left: 85px"></el-input>
        </el-form-item>
        <el-form-item
          label="国家名称-中文:"
          :label-width="formLabelWidth"
          prop="nationCH"
        >
          <el-input
            v-model="form.nationCH"
            autocomplete="off"
            style="width: 58%; margin-left: 85px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="国家名称-英文:"
          :label-width="formLabelWidth"
          prop="nationEN"
          :rules="[
            {
              required: true,
              message: '请输入国家名称-英文',
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            v-model="form.nationEN"
            autocomplete="off"
            style="width: 58%; margin-left: 85px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="默认货币:"
          prop="currencyCode"
          :label-width="formLabelWidth"
          :rules="[
            { required: true, message: '请输入默认货币', trigger: 'blur' },
            {
              pattern: /^[A-Z]{1,3}$/,
              message: '请输入正确的货币类型',
              trigger: ['blur', 'change'],
            },
          ]"
        >
          <el-input
            v-model="form.currencyCode"
            autocomplete="off"
            style="width: 58%; margin-left: 85px"
          ></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="dataSave()">保存</el-button>
          <el-button @click="cancel()">取 消</el-button>
        </span>
      </template>
    </el-dialog>
    <!--修改 dialog-->
    <el-dialog title="修改国家" v-model="changeCountryFlag">
      <el-form :model="changeForm" ref="checkInput">
        <el-form-item label="国家代码:" :label-width="formLabelWidth">
          <el-select
            disabled
            style="width: 58%; margin-left: 85px"
            class="myselect_inner myicon_inner"
            v-model="changeForm.countryCode"
            placeholder="请选择"
          >
            <el-option
              v-for="item in nationoption"
              :key="item.value"
              :label="item.countryCode"
              :value="item.countryCode"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="国家名称-中文:"
          :label-width="formLabelWidth"
          prop="nationCH"
        >
          <el-input
            v-model="changeForm.nationCH"
            autocomplete="off"
            style="width: 58%; margin-left: 85px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="国家名称-英文:"
          :label-width="formLabelWidth"
          prop="nationEN"
          :rules="[
            {
              required: true,
              message: '请输入国家名称-英文',
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            v-model="changeForm.nationEN"
            autocomplete="off"
            style="width: 58%; margin-left: 85px"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="currencyCode"
          label="默认货币:"
          :label-width="formLabelWidth"
          :rules="[
            { required: true, message: '请输入默认货币', trigger: 'blur' },
            {
              pattern: /^[A-Z]{1,3}$/,
              message: '请输入正确的货币类型',
              trigger: ['blur', 'change'],
            },
          ]"
        >
          <el-input
            required
            v-model="changeForm.currencyCode"
            autocomplete="off"
            style="width: 58%; margin-left: 85px"
          ></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="changeSave()">保存</el-button>
          <el-button @click="cancel()">取 消</el-button>
        </span>
      </template>
    </el-dialog>
    <!--关联映射-->
    <el-dialog title="关联映射" v-model="bindMappingFlag">
      <el-form :model="bindMappingForm" ref="bindMappingInput">
        <el-form-item label="GEO编码:" :label-width="formLabelWidth">
          <el-input
            disabled
            v-model="bindMappingForm.GEOCode"
            autocomplete="off"
            style="width: 58%; margin-left: 85px"
          ></el-input>
        </el-form-item>
        <el-form-item label="第三方系统:" :label-width="formLabelWidth">
          <el-select
            style="width: 58%; margin-left: 85px"
            class="myselect_inner myicon_inner"
            v-model="bindMappingForm.remoteSystemCode"
            placeholder="请选择"
          >
            <el-option
              v-for="item in remoteSystemList"
              :key="item.code"
              :label="item.value"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="第三方系统编码:"
          :label-width="formLabelWidth"
          prop="remoteSystemMappingCode"
          :rules="[
            {
              required: true,
              message: '请输入第三方系统编码',
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            required
            v-model="bindMappingForm.remoteSystemMappingCode"
            autocomplete="off"
            style="width: 58%; margin-left: 85px"
          ></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="saveMapping()">保存</el-button>
          <el-button @click="cancel('bindMappingFlag')">取 消</el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog title="警告" v-model="dialogVisible" width="30%">
      <span>{{
        this.delMappingMsg !== ""
          ? this.delMappingMsg
          : "将删除该国家及相关所有省市信息，请确认是否删除"
      }}</span>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="confirmDelete">确 定</el-button>
          <el-button @click="cancelDelete">取 消</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {
  getcountryList,
  savecountryList,
  deletecountryList,
  buttonEnable,
  fetchMapping,
  deleteMapping,
  saveMapping,
} from "@/api/shoppingData";
import ConfirmBoxs from "@/components/confirmBoxs.vue";
export default {
  name: "HBECountry",
  components: {
    ConfirmBoxs,
  },
  data() {
    return {
      dialogVisible: false,
      changeLoading: false,
      deleteFlag: false,
      deleteparams: {},
      confirmFlag: false,
      changeRow: {},
      CountryCode: "",
      currentPage1: 1,
      //新增dialog
      confirmIcon: "",
      confirmMsg: "",
      dialogFormVisible: false,
      changeCountryFlag: false,
      form: {
        countryCode: "",
        nationCH: "",
        nationEN: "",
        currencyCode: "",
      },
      changeForm: {
        countryCode: "",
        nationCH: "",
        nationEN: "",
        currencyCode: "",
        id:"",
      },
      //
      formLabelWidth: "150px",
      selectnation: "",
      selectprovince: "",
      locationCode: "",
      paramsCitycode: "",
      citycode: "",
      cityCode: "",
      clickRow: {},
      tableData: [],
      searchForm: {
        nation: "",
        total: null,
      },
      nationoption: [],
      bindMappingFlag: false,
      remoteSystemList: [
        {
          code: "FX",
          value: "FX",
        },
      ],
      bindMappingForm: {
        GEOCode: "",
        remoteSystemCode: "FX",
        remoteSystemMappingCode: "",
      },
      delMappingMsg: "",
    };
  },
  mounted() {
    this.getCountryList();
  },
  methods: {
    //分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.customSearch(val);
      console.log(`当前页: ${val}`);
    },

    enable(data) {
      let getParams = {
        params: {
          type: 0,
          code: data.countryCode,
          action: 1,
        },
      };
      console.log(getParams, "getParams");
      this.getBtnDisplay(getParams);
    },
    disabled(data) {
      let getParams = {
        params: {
          type: 0,
          code: data.countryCode,
          action: 0,
        },
      };
      console.log(getParams, "getParams");
      this.getBtnDisplay(getParams);
    },
    async getBtnDisplay(getParams) {
      this.changeLoading = true;
      console.log(getParams, "传参");
      await buttonEnable(getParams).then((res) => {
        if (res.code === 200) {
          this.changeLoading = false;
          this.customSearch();
          console.log(res, "res====>");
        }
      });
    },
    //获取搜索下拉值-国省市
    async getCountryList() {
      this.changeLoading = true;
      let searchparams = {
        params: {
          countryCode: "",
        },
      };
      await getcountryList(searchparams)
        .then((res) => {
          if (res.code === 200) {
            this.nationoption = res.data.list;
            this.changeLoading = false;
            console.log("获取国家下拉值", res.data.list);
          } else {
            this.confirmFlag = true;
            this.deleteFlag = false;
            this.changeLoading = false;
            this.confirmMsg = "数据请求失败";
          }
        })
        .catch(function (error) {
          this.changeLoading = false;
          console.log("国家下拉值 请求失败", error.objError);
        });
    },

    //国家change事件
    selectNation(value) {
      this.selectnation = value;
      console.log(this.selectnation);
    },
    addCountry() {
      this.dialogFormVisible = true;
    },
    //新增保存
    async dataSave() {
      this.$refs["checkInput"].validate((valid) => {
        if (valid) {
          this.changeLoading = true;
          let saveParams = {
            countryCode: this.form.countryCode,
            countryName: this.form.nationCH,
            DefaultCurrencyCode: this.form.currencyCode,
            countryNameLists: [
              {
                languageCode: "zh-CN",
                name: this.form.nationCH,
                description: "",
              },
              {
                languageCode: "en",
                name: this.form.nationEN,
                description: "",
              },
            ],
          };
          console.log(saveParams, "saveParams");

          this.saveNew(saveParams);
          this.dialogFormVisible = false;
        }
      });
    },
    async saveNew(saveParams) {
      await savecountryList(saveParams)
        .then((res) => {
          if (res.code == 200) {
            this.changeLoading = false;
            if (res.data.error.code === 2001) {
              this.confirmFlag = true;
              this.confirmMsg = res.data.error.message;
              this.dialogFormVisible = true;
            } else {
              this.confirmFlag = true;
              this.deleteFlag = false;
              this.confirmMsg = "新增成功";
              this.form.countryCode = "";
              this.form.nationEN = "";
              this.form.nationCH = "";
              this.form.currencyCode = "";
              this.getCountryList();
              this.customSearch();
            }
          } else {
            this.changeLoading = false;
            this.confirmFlag = true;
            this.deleteFlag = false;
            this.confirmMsg = "新增失败";
            this.customSearch();
          }
        })
        .catch(function (error) {
          this.changeLoading = false;
          console.log("新增失败", error.objError);
          this.customSearch();
        });
    },
    // 修改保存
    async changeSave() {
      this.$refs["checkInput"].validate((valid) => {
        if (valid) {
          this.changeLoading = true;
          let saveParams = {
            id: this.changeForm.id,
            countryCode: this.changeForm.countryCode,
            countryName: this.changeForm.nationCH,
            DefaultCurrencyCode: this.changeForm.currencyCode,
            countryNameLists: [
              {
                languageCode: "zh-CN",
                name: this.changeForm.nationCH,
                description: "",
              },
              {
                languageCode: "en",
                name: this.changeForm.nationEN,
                description: "",
              },
            ],
          };
          console.log(saveParams, "修改保存参数");
          this.saveChange(saveParams);
          this.changeCountryFlag = false;
        }
      });
    },
    async saveChange(saveParams) {
      await savecountryList(saveParams)
        .then((res) => {
          if (res.code == 200) {
            this.changeLoading = false;
            if (res.data.error.code === 2001) {
              this.confirmFlag = true;
              this.confirmMsg = res.data.error.message;
              this.dialogFormVisible = true;
            } else {
              this.confirmFlag = true;
              this.deleteFlag = false;
              this.confirmMsg = "修改成功";
              this.getCountryList();
              this.customSearch();
            }
          } else {
            this.changeLoading = false;
            this.confirmFlag = true;
            this.deleteFlag = false;
            this.confirmMsg = "error";
            this.customSearch();
          }
        })
        .catch(function (error) {
          this.changeLoading = false;
          console.log("修改失败", error.objError);
          this.customSearch();
        });
    },
    // 保存关联映射
    saveMapping() {
      this.$refs["bindMappingInput"].validate(async (valid) => {
        if (valid) {
          console.log(this.bindMappingForm);
          const bindMappingForm = this.bindMappingForm;
          this.changeLoading = true;
          this.bindMappingFlag = false;
          const saveMappingRequests = {
            type: "countrymapping",
            data: {
              countryCode: bindMappingForm.countryCode,
              countryId: bindMappingForm.countryId,
              remoteSystemCode: bindMappingForm.remoteSystemCode,
              remoteSystemCountryCode: bindMappingForm.remoteSystemMappingCode,
              userName: this.$objBaseInfo.loginID,
            },
          };
          console.log(saveMappingRequests);
          let confirmMsg = "";
          await saveMapping(saveMappingRequests)
            .then(async (res) => {
              console.log(res);
              if (res.code === 200) {
                if (res.data.status === 1) {
                  confirmMsg = "已成功关联映射";
                } else {
                  confirmMsg = "关联映射失败，请重新操作";
                }
              } else {
                confirmMsg = res.data.error.message;
              }
            })
            .catch(function (error) {
              console.log("修改失败", error.objError);
            });
          if (confirmMsg !== "") {
            this.changeLoading = false;
            this.confirmFlag = true;
            this.confirmMsg = confirmMsg;
          }
        }
      });
    },
    // 关联映射
    async bindMapping(row) {
      console.log(row);
      const fetchMappingRequests = {
        type: "countrymapping",
        paramsObj: {
          params: {
            countryCode: row.countryCode,
            remoteSystemCode: "FX",
          },
        },
      };
      var fetchMappingData = await fetchMapping(fetchMappingRequests);
      console.log(fetchMappingData);
      this.bindMappingFlag = true;
      let bindMappingForm = this.bindMappingForm;
      bindMappingForm.GEOCode = row.countryCode;
      bindMappingForm.remoteSystemMappingCode =
        fetchMappingData.data.length > 0
          ? fetchMappingData.data[0].remoteSystemCountryCode
          : "";
      this.bindMappingForm = { ...bindMappingForm, ...row };
    },
    // 删除映射
    async deleteMapping(row) {
      const that = this;
      const fetchMappingRequests = {
        type: "countrymapping",
        paramsObj: {
          params: {
            countryCode: row.countryCode,
            remoteSystemCode: "FX",
          },
        },
      };
      console.log(fetchMappingRequests);
      let confirmMsg = "";
      await fetchMapping(fetchMappingRequests)
        .then(async (res) => {
          if (res.code === 200) {
            if (res.data.length > 0) {
              that.dialogVisible = true;
              that.delMappingMsg = "您将删除当前国家的关联映射，是否继续？";
              let resData = { ...res.data[0], ...row };
              that.changeRow = resData;
            } else {
              confirmMsg = "暂未查询到该国家的映射数据";
            }
          } else {
            confirmMsg = "查询映射失败，请重新操作";
          }
        })
        .catch(function (error) {
          console.log("修改失败", error.objError);
        });
      if (confirmMsg !== "") {
        this.confirmMsg = confirmMsg;
        this.confirmFlag = true;
      }
    },
    async confirmDelMapping() {
      console.log(this.changeRow);
      let confirmMsg = "";
      const deleteMappingRequests = {
        type: "countrymapping",
        paramsObj: {
          params: {
            countryCode: this.changeRow.countryCode,
            userName: this.$objBaseInfo.loginID,
            remoteSystemCountryCode: this.changeRow.remoteSystemCountryCode,
            remoteSystemCode: this.changeRow.remoteSystemCode,
          },
        },
      };
      await deleteMapping(deleteMappingRequests)
        .then((res) => {
          console.log(res);
          if (res.code === 200) {
            console.log(res.data);
            if (!res.status) {
              confirmMsg = "删除映射失败";
            } else {
              confirmMsg = "映射已删除";
            }
          } else {
            confirmMsg = "删除映射失败";
          }
        })
        .catch(function (error) {
          this.delMappingMsg = "";
          console.log("删除映射失败", error.objError);
        });
      if (confirmMsg !== "") {
        this.delMappingMsg = "";
        this.confirmMsg = confirmMsg;
        this.confirmFlag = true;
      }
    },
    //修改button
    handleChange(row) {
      this.changeRow = row;
      this.changeCountryFlag = true;
      this.changeForm.countryCode = this.changeRow.countryCode;
      this.changeForm.nationEN = this.changeRow.countryNameLists["en"];
      this.changeForm.nationCH = this.changeRow.countryNameLists["zh-CN"];
      this.changeForm.currencyCode = this.changeRow.currencyCode;
      this.changeForm.id = this.changeRow.countryId;
    },
    //取消button
    cancel(key) {
      if (key === "bindMappingFlag") {
        this.$refs.bindMappingInput.clearValidate();
        this.bindMappingFlag = false;
        this.delMappingMsg = "";
        this.bindMappingForm.remoteSystemMappingCode = "";
      } else {
        this.$refs.checkInput.clearValidate();
        this.dialogFormVisible = false;
        this.changeCountryFlag = false;
        this.form.countryCode = "";
        this.form.nationEN = "";
        this.form.nationCH = "";
        this.form.currencyCode = "";
      }
    },
    //删除
    async deleteRow(row) {
      this.dialogVisible = true;
      this.deleteparams = {
        params: {
          countryCode: row.countryCode,
        },
      };
    },
    cancelDelete() {
      this.dialogVisible = false;
    },
    confirmDelete() {
      this.dialogVisible = false;
      if (this.delMappingMsg !== "") {
        this.confirmDelMapping();
        return false;
      }
      deletecountryList(this.deleteparams)
        .then((res) => {
          if (res.code == 200) {
            this.changeLoading = false;
            this.confirmFlag = true;
            this.confirmMsg = "删除成功";
            this.deleteFlag = false;
            this.customSearch();
          } else {
            this.changeLoading = false;
            this.confirmFlag = true;
            this.confirmMsg = "删除失败";
            this.deleteFlag = false;
            this.customSearch();
          }
        })
        .catch(() => {
          this.changeLoading = false;
          this.confirmFlag = true;
          this.confirmMsg = "删除失败";
          this.deleteFlag = false;
          this.customSearch();
        });
    },
    //搜索button
    async customSearch(int) {
      this.changeLoading = true;
      let searchparams = {
        params: {
          countryCode: this.selectnation,
          page: int ? int : 1,
          per_page: 10,
        },
      };
      await getcountryList(searchparams)
        .then((res) => {
          if (res.code === 200) {
            res.data.list.map((item) => {
              if (item.isEnable === 1) {
                item.enableFlag = false;
                item.disabledFlag = true;
              } else if (item.isEnable === 0) {
                item.enableFlag = true;
                item.disabledFlag = false;
              }
              return item;
            });
            this.currentPage1 = res.data.pageNumber;
            this.changeLoading = false;
            this.tableData = res.data.list;
            this.searchForm.total = res.data.total;
          } else {
            this.changeLoading = false;
            this.confirmFlag = true;
            this.confirmMsg = "获取信息失败，请稍后重试";
            this.deleteFlag = false;
          }
        })
        .catch(function (error) {
          console.log("位置信息 请求失败", error.objError);
        });
    },
    setConfirmFlag(value) {
      this.changeLoading = false;
      this.confirmFlag = value;
    },
    updateIntlTaxDisplay(row){
      let saveParams = {
        id: row.countryId,
        countryCode: row.countryCode,
        countryName: row.countryName,
        DefaultCurrencyCode: row.currencyCode,
        countryNameLists: [
          {
            languageCode: "zh-CN",
            name: row.countryNameLists["zh-CN"],
            description: "",
          },
          {
            languageCode: "en",
            name: row.countryNameLists["en"],
            description: "",
          },
        ],
        intlTaxDisplay:row.intlTaxDisplay == 0 ? 1 : 0
      };
      this.saveChange(saveParams);
    }
  },
};
</script>

<style scoped>
.loading {
  z-index: 999999;
}
.paginationsty {
  float: right;
  margin: 1rem 0;
}
.pos_container_panel {
  padding: 0 16rem 4rem;
}
.harpIDbtn {
  width: 10rem;
  height: 3rem;
  padding: 0 !important;
  font-size: 1rem !important;
}
</style>
